/* eslint-disable */
import { FC, useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
  Button,
  Grid,
  Typography,
  TextField,
  Box,
  FormHelperText,
  Dialog,
  IconButton,
} from '@material-ui/core';
import { useStyles } from '../style';
import useAuth from 'src/hooks/useAuth';
import { Formik } from 'formik';
import XIcon from 'src/icons/X';
import useIsMountedRef from 'src/hooks/useIsMountedRef';
import { bank } from './bankEntites.js';
import { updateBusiness } from '../bridges/BridgeBusiness';

interface IModalContractProps { }

const bancoOptions = bank;

// [
//   { text: 'PICHINCHA', value: 'PICHINCHA' },
//   { text: 'PACIFICO', value: 'PACIFICO' },
//   { text: 'GUAYAQUIL', value: 'GUAYAQUIL' },
//   { text: 'INTERNACIONAL', value: 'INTERNACIONAL' },
// ];

const tipoCuentaOptions = [
  { text: 'AHORRO', value: 'AHO' },
  { text: 'CORRIENTE', value: 'CORR' },
];

const ModalBankData: FC<IModalContractProps> = (props) => {
  const isMountedRef = useIsMountedRef();
  const { user } = useAuth();
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState(true);

  const handleClose = () => {
    setModalOpen(false);
  };

  useEffect(() => { }, []);

  return (
    <Dialog open={modalOpen} onClose={handleClose} fullWidth maxWidth={'md'} scroll="paper">
      <Box display="flex" justifyContent="flex-end">
        <IconButton onClick={handleClose}>
          <XIcon fontSize="small" />
        </IconButton>
      </Box>
      <Box sx={{ margin: 5 }}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography color="#024787" fontSize="24px" fontWeight={700}>
              {`Hola ${user.businessId.company}`}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography color="#405364" fontSize="16px">
              Han pasado 3 meses y{' '}
              <span style={{ fontWeight: 700 }}>
                el periodo de prueba gratuito ha llegado a su fin.
              </span>{' '}
              Sin embargo, puedes continuar aprovechando los beneficios de
              Release{' '}
              <span style={{ fontWeight: 700 }}>
                ingresando los datos de tu cuenta para realizar el cobro por
                cada transacción realizada
              </span>{' '}
              según lo establecido en el{' '}
              <span style={{ fontWeight: 700 }}>
                <a href="/dashboard/contract" style={{ color: '#fcbe00' }}>
                  contrato
                </a>
              </span>
              .
            </Typography>
          </Grid>
          <Box sx={{ margin: 5 }}>
            <Formik
              initialValues={{
                banco: '',
                tipoCuenta: '',
                cuenta: '',
                submit: null,
              }}
              validationSchema={Yup.object().shape({
                banco: Yup.string().required('Requerido'),
                tipoCuenta: Yup.string().required('Requerido'),
                cuenta: Yup.string()
                  .min(6, 'Ingresa un número correcto')
                  .required('Requerido'),
              })}
              onSubmit={async (
                values,
                { setErrors, setStatus, setSubmitting }
              ): Promise<void> => {
                try {
                  let obj = {
                    businessId: user.businessId.business_id,
                    bankData: {
                      bank: values.banco,
                      account_number: values.cuenta,
                      account_type: values.tipoCuenta,
                    },
                  };
                  await updateBusiness(obj);
                  window.location.reload();
                  if (isMountedRef.current) {
                    setStatus({ success: true });
                    setSubmitting(false);
                  }
                } catch (err) {
                  console.error(err);
                  if (isMountedRef.current) {
                    setStatus({ success: false });
                    setErrors({ submit: err.message });
                    setSubmitting(false);
                  }
                }
              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                isSubmitting,
                touched,
                values,
              }): JSX.Element => (
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item md={6} xs={12}>
                      <TextField
                        error={Boolean(touched.banco && errors.banco)}
                        fullWidth
                        helperText={touched.banco && errors.banco}
                        label="Banco"
                        name="banco"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        select
                        SelectProps={{ native: true }}
                        value={values.banco}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      >
                        <option aria-label="None" value="" disabled></option>
                        {bancoOptions.map((element, i) => {
                          return (
                            <option key={i}>{element.Nombre_Banco}</option>
                          );
                        })}
                      </TextField>
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <TextField
                        error={Boolean(touched.tipoCuenta && errors.tipoCuenta)}
                        fullWidth
                        helperText={touched.tipoCuenta && errors.tipoCuenta}
                        label="Tipo de Cuenta"
                        name="tipoCuenta"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        select
                        SelectProps={{ native: true }}
                        value={values.tipoCuenta}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      >
                        <option aria-label="None" value="" disabled></option>
                        {tipoCuentaOptions.map((element, i) => {
                          return <option key={i}>{element.text}</option>;
                        })}
                      </TextField>
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <TextField
                        error={Boolean(touched.cuenta && errors.cuenta)}
                        fullWidth
                        helperText={touched.cuenta && errors.cuenta}
                        label="N° de Cuenta Bancaria"
                        name="cuenta"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.cuenta}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                  {errors.submit && (
                    <Box sx={{ mt: 3 }}>
                      <FormHelperText error>{errors.submit}</FormHelperText>
                    </Box>
                  )}
                  <Box
                    sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}
                  >
                    <Button
                      disabled={
                        isSubmitting ||
                        values.banco == '' ||
                        values.tipoCuenta == '' ||
                        values.cuenta == ''
                      }
                      // fullWidth
                      size="large"
                      type="submit"
                      variant="contained"
                      sx={{ backgroundColor: '#024787', borderRadius: '16px' }}
                    >
                      ENVIAR DATOS
                    </Button>
                  </Box>
                </form>
              )}
            </Formik>
          </Box>
        </Grid>
      </Box>
    </Dialog>
  );
};

ModalBankData.propTypes = {};

export default ModalBankData;
